import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { IntlProvider } from 'react-intl';
import { SUPPORTED_LANGUAGES } from '../../shared/Constants';
import BasicErrorBoundary from '../../shared/components/errorBoundaries/BasicErrorBoundary';

class RootIntl extends PureComponent {
    static mapStateToProps = (state) => {
        const { language } = state;
        return {
            locale: language.languageCode,
            messages: language.messages
        };
    };

    static mapDispatchToProps = null;

    static propTypes = {
        locale: PropTypes.oneOf([
            SUPPORTED_LANGUAGES.en.languageCode,
            SUPPORTED_LANGUAGES.ko.languageCode,
            SUPPORTED_LANGUAGES.en.languageCode,
            SUPPORTED_LANGUAGES.pt.languageCode,
            'default'
        ]),
        messages: PropTypes.object,
        children: PropTypes.any
    };

    render() {
        const { locale, messages } = this.props;

        const key = locale && isEmpty(messages) ? 'default' : locale;
        return (
            <IntlProvider locale={locale} key={key} messages={messages} textComponent={Fragment}>
                <BasicErrorBoundary>{this.props.children}</BasicErrorBoundary>
            </IntlProvider>
        );
    }
}

const RootIntlComponent = RootIntl;
const ConnectedRootIntl = connect(RootIntl.mapStateToProps, RootIntl.mapDispatchToProps)(RootIntl);

export { RootIntlComponent, ConnectedRootIntl as RootIntl };
